import axios from 'axios'

// Mirrors the token handling in @peracto/client (revalidateUser), which isn't exported:
// refresh an expired token before calling the API, and send the user to login on a 401.

const clearLocalStorage = () => {
    localStorage.removeItem('token')
    localStorage.removeItem('claims')
    localStorage.removeItem('expires_at')
    localStorage.removeItem('refresh_token')
}

const redirectToLogin = () => {
    clearLocalStorage()
    window.location.href = '/login'
}

const decodeJwt = (token) =>
    JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')))

const refreshTokenIfExpired = async (apiUrl) => {
    const expiresAt = Number(localStorage.getItem('expires_at'))

    if (!expiresAt || expiresAt * 1000 > Date.now()) {
        return
    }

    try {
        const { data } = await axios.post(`${apiUrl}/token/refresh`, {
            refresh_token: localStorage.getItem('refresh_token'),
        })
        const claims = decodeJwt(data.token)

        localStorage.setItem('token', data.token)
        localStorage.setItem('claims', JSON.stringify(claims))
        localStorage.setItem('expires_at', claims.exp)
        localStorage.setItem('refresh_token', data.refresh_token)
    } catch (e) {
        if (e?.response?.status === 401) {
            redirectToLogin()
        }
        throw e
    }
}

export const authorisedGet = async (apiUrl, path) => {
    await refreshTokenIfExpired(apiUrl)

    try {
        return await axios.get(`${apiUrl}${path}`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        })
    } catch (e) {
        if (e?.response?.status === 401) {
            redirectToLogin()
        }
        throw e
    }
}
